import { useExceptionsSummary } from "@/hooks/use-exceptions-summary";

export function useExceptionsCounter(): number {
  const { data } = useExceptionsSummary();

  const total = data?.summary.reduce((sum, cat) => sum + cat.total, 0) ?? 0;

  return total;
}
